export class JobProgressStepThreatDetectionData {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "scanner",
            "baseName": "scanner",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return JobProgressStepThreatDetectionData.attributeTypeMap;
    }
    constructor() {
    }
}
